module.exports = __webpack_public_path__ + "img/img1.b9b12906.png";